function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  className: "pos"
}, /*#__PURE__*/React.createElement("path", {
  d: "M200,0H0v200C0,89.54,89.54,0,200,0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M200,400h200V200C400,310.46,310.46,400,200,400z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,200v200h200C89.54,400,0,310.46,0,200z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M200,0c110.46,0,200,89.54,200,200V0H200z"
}));

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  className: "neg",
  cx: 200,
  cy: 200,
  r: 200
});

var SvgShapeFullCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  x: "0px",
  y: "0px",
  width: "400px",
  height: "400px",
  viewBox: "0 0 400 400",
  style: {
    enableBackground: "new 0 0 400 400"
  },
  xmlSpace: "preserve"
}, props), _ref, _ref2);

export default __webpack_public_path__ + "static/media/shape-full_circle.fcb438ca.svg";
export { SvgShapeFullCircle as ReactComponent };